import { AuthenticationToken } from '../../external/shared/api/EnrollmentClient.generated';

export function readAuthToken(): AuthenticationToken | null {
  try {
    const token = localStorage.getItem('authToken');
    if (token) return JSON.parse(token) as AuthenticationToken;
  } catch {
    return null;
  }
  return null;
}

export function extractCountryAndCulture(
  token: AuthenticationToken | null
): { country: string; culture: string } {
  const country = token?.country?.toUpperCase?.() ?? '';
  const culture = token?.culture ?? '';
  return { country, culture };
}

const APAC_NFR_COUNTRIES = new Set<string>([
  'THA',
  'TH',
  'BGD',
  'BD',
  'BRN',
  'BN',
  'KHM',
  'KH',
  'FJI',
  'FJ',
  'LAO',
  'LA',
  'MDV',
  'MV',
  'MHL',
  'MH',
  'FSM',
  'FM',
  'MNG',
  'MN',
  'NPL',
  'NP',
  'NCL',
  'NC',
  'MNP',
  'MP',
  'PLW',
  'PW',
  'PNG',
  'PG',
  'WSM',
  'WS',
  'SYC',
  'SC',
  'SLB',
  'SB',
  'LKA',
  'LK',
  'TON',
  'TO',
  'VNM',
  'VN',
  'WLF',
  'WF'
]);

export const APAC_NFR_LANG_FLAG = 'ap_NF';

export function isApacNfrCountry(country?: string): boolean {
  if (!country) return false;
  return APAC_NFR_COUNTRIES.has(country.toUpperCase());
}

export function resolveChatCountry(
  fallbackCountryIso3: string,
  tokenCountry?: string
): string | undefined {
  const baseCountry = fallbackCountryIso3?.toUpperCase?.() ?? '';
  const countryFromToken = tokenCountry?.toUpperCase?.() ?? '';
  const country = countryFromToken || baseCountry;

  if (!country) return undefined;
  if (isApacNfrCountry(country)) return APAC_NFR_LANG_FLAG;
  return country;
}

export function resolveHtmlLang(baseLocale: string, country?: string, culture?: string): string {
  const normalizedCountry = country?.toUpperCase?.() ?? '';
  if (isApacNfrCountry(normalizedCountry)) return APAC_NFR_LANG_FLAG;

  if (normalizedCountry === 'ZA' || normalizedCountry === 'ZAF') return 'en-za';
  if (culture && culture !== baseLocale) return culture;

  return baseLocale;
}

